import React from 'react';
import TimeTicketForm from './timeticketform';
import TimeTicketEntryList from './timeticketentrylist';


const TimeTicketEntryAndEdit = ({user}) => {
    return (
        <div className='grid grid-cols-5 mx-auto items-center justify-center pt-2'>
            <div className='col-span-1 mx-auto w-full gradient-bg rounded-r-2xl border-2 border-gray-500 shadow-2xl'>
                <TimeTicketForm/>
            </div>
            <div className='col-span-4 mx-auto w-full'>
                <TimeTicketEntryList user={user}/>
            </div>
        </div>
    );
};

export default TimeTicketEntryAndEdit;